var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 18,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.72 4.70667L13.7333 2.18667C13.5933 2.07778 13.4067 2 13.22 2H13.1889H6.74889H3.77778C3.34222 2 3 2.34222 3 2.77778V15.2222C3 15.6578 3.34222 16 3.77778 16H16.2222C16.6578 16 17 15.6578 17 15.2222V5.31333C17 5.08 16.8911 4.86222 16.72 4.70667ZM12.4267 3.55556V7.56889H7.52667V3.55556H12.4267ZM4.55556 14.4444H15.4444V5.65556L13.9822 4.42667V8.34667C13.9822 8.78222 13.64 9.12444 13.2044 9.12444H6.74889C6.31333 9.12444 5.97111 8.78222 5.97111 8.34667V3.55556H4.55556V14.4444Z",
    fill: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2398 6.36C11.7398 6.36 12.1398 5.96 12.1398 5.46V3.9C12.1398 3.4 11.7398 3 11.2398 3C10.7398 3 10.3398 3.4 10.3398 3.9V5.46C10.3398 5.96 10.7598 6.36 11.2398 6.36Z",
    fill: "#7E7E7E"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.68901a6c.svg";
export { ForwardRef as ReactComponent };